import _ from 'lodash';

import Entity from './Entity';

import Payor from './Payor';
import Parker from './Parker';
import BillingProfile from './BillingProfile';
import Invoice from './Invoice';
import Credit from './Credit';

const fieldsWithDynamicAllowedValues = {
  status: { enumName: 'SubscriptionStatusEnum' }
};

const fieldsWithStaticAllowedValues = {
  mail_invoices: {
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' }
    ]
  },
  tax_exempt: {
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' }
    ]
  }
};


export default class Subscription {
  fields = {
    id: {
      value: null
    },
    account_id: {
      value: null
    },
    subscription_name: {
      value: null
    },
    status: {
      value: null
    },
    payment_method_id: {
      value: null
    },
    auto_pay: {
      value: null
    },
    mail_invoices: {
      value: null
    },
    tax_exempt: {
      value: null
    },
    payor: {
      value: null
    },
    parkers: {
      value: []
    },
    billing_profile: {
      value: null
    },
    credit: {
      value: []
    },
    invoices: {
      value: []
    },
    subscription_invoice_notes: {
      value: null
    },
    numberOfParkingSpaces: {
      value: null
    },
    achDisabled: {
      value: null
    }
  };

  getBalance() {
    const totalBalance = this.fields.invoices.value.reduce((total, invoice) => {
      return (total + invoice.fields.balance.value)
    }, 0);
    return totalBalance;
  }

  static createFromQueryValues(values) {
    const subscription = new this();

    for (let field in subscription.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'payor':
            subscription.fields[field].value = (values[field] === null) ?
              values[field] :
              Payor.createFromQueryValues(values[field]);
            break;
          case 'parkers':
            if (Array.isArray(values[field])) {
              for (let parker of values[field]) {
                subscription.fields[field].value.push(Parker.createFromQueryValues(parker));
              }
            }
            break;
          case 'billing_profile':
            subscription.fields[field].value = (values[field] === null) ?
              values[field] :
              BillingProfile.createFromQueryValues(values[field]);
            break;
          case 'credit':
            if (Array.isArray(values[field])) {
              for (let credit of values[field]) {
                subscription.fields[field].value.push(Credit.createFromQueryValues(credit));
              }
            }
            break;
          case 'invoices':
            if (Array.isArray(values[field])) {
              for (let invoice of values[field]) {
                subscription.fields[field].value.push(Invoice.createFromQueryValues(invoice));
              }
            }
            break;
          default:
            subscription.fields[field].value = values[field];
        }
      }
    }

    return subscription;
  }


  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      fieldsWithStaticAllowedValues,
      fieldsWithDynamicAllowedValues,
      fields
    );
  }


  getQueryFieldValues() {
    const values = _.cloneDeep(SubscriptionInput);

    for (let field in values) {
      switch (field) {
        case 'survey_responses':
          break;
        default:
          values[field] = this.fields[field].value;
      }
    }

    return values;
  }
  
  calculateCreditBalance() {
    return this.fields.credit.value.reduce((accumulator, credit) => {
      return accumulator + credit.fields.balance.value;
    }, 0);
  }

}

export const SubscriptionInput = {
  subscription_name: null,
  payment_method_id: null,
  auto_pay: null,
  mail_invoices: null,
  tax_exempt: null,
  survey_responses: [],
  subscription_invoice_notes: null,
  numberOfParkingSpaces: null,
}
